module.exports = __webpack_public_path__ + "img/e2ba4176fd04f354a569f27239e2a9f5.455a1c20.jpg";